import { Popover } from '@amzn/storm-ui';
import { FormRow } from '@amzn/storm-ui-column-form-kit';
import DatePicker, { DatePickerInput } from '@amzn/storm-ui-date-picker';
import { useTranslation } from 'react-i18next';
import { DatePickerWrapperProps } from './constants/interfaces';
import { StatusTypes } from '../../constants/statusTypes';
import { StylesInlineMessage } from './DatePickerWrapper.styles';
import { getDatePickerProps } from './constants/configs';

const DatePickerWrapper = ({
  config,
  index,
  startDate,
  endDate,
  activeStartDatePicker,
  activeEndDatePicker,
  selectedStart,
  selectedEnd,
  anchorRefStart,
  anchorRefEnd,
  setActiveStartDatePicker,
  setActiveEndDatePicker,
  handleDateSelect,
  validationErrors,
}: DatePickerWrapperProps) => {
  const { t } = useTranslation();
  const todayDate = new Date();
  const isStartDate = index === 0;
  const isActive = isStartDate ? activeStartDatePicker : activeEndDatePicker;
  const selectedValue = isStartDate ? selectedStart : selectedEnd;
  const inputRef = isStartDate ? anchorRefStart : anchorRefEnd;
  const date = isStartDate ? startDate : endDate;
  const errorMessage = isStartDate
    ? validationErrors?.startDate
    : validationErrors?.endDate;

  const togglePopover = () => {
    if (isStartDate) {
      setActiveStartDatePicker(!activeStartDatePicker);
      setActiveEndDatePicker(false);
    } else {
      setActiveStartDatePicker(false);
      setActiveEndDatePicker(!activeEndDatePicker);
    }
  };

  const datePickerProps = getDatePickerProps(isStartDate, startDate, todayDate);

  return (
    <FormRow
      id={config.id}
      label={t(config.labelKey)}
      controlComponents={[
        () => (
          <>
            <Popover
              id={config.popoverId}
              isOpen={isActive}
              onCloseButtonClick={togglePopover}
              position="bottom"
              align="start"
              autoFocus
              trigger={
                <DatePickerInput
                  id={config.pickerId}
                  value={selectedValue}
                  readOnly
                  inputRef={inputRef}
                  onClick={togglePopover}
                  prefixAriaLabel={t(config.ariaLabelKey)}
                  statusType={
                    errorMessage ? StatusTypes.ERROR : StatusTypes.SUCCESS
                  }
                />
              }
            >
              <DatePicker
                onChange={(date) => handleDateSelect(date, isStartDate)}
                date={date}
                minDate={datePickerProps.minDate}
                monthInView={datePickerProps.monthInView}
              />
            </Popover>
            {!!errorMessage && (
              <StylesInlineMessage message={errorMessage} variant="error" />
            )}
          </>
        ),
      ]}
      {...(errorMessage && {
        helperText: errorMessage,
      })}
    />
  );
};

export default DatePickerWrapper;
